<template>
  <v-container>
    <v-row>
      <v-col cols="6">
        <v-img
          :src="require('../assets/atinet.png')"
          class="my-3"
          contain
          height="200"
        />
        <h1 class="display-2 font-weight-bold mb-3">
          {{ userAuth.nombre }}
        </h1>
        <h1 class="display-2 font-weight-bold mb-3">BIENVENIDO A ATINET</h1>
        <p class="subheading font-weight-regular">
          Sistema de gestión de materiales
        </p>
      </v-col>
      <v-col cols="6">
        <v-row>
          <v-col v-for="(item, i) in items" :key="i" cols="4" class="mb-4">
            <v-card
              v-if="userType === 'Administrador' || (userType.includes('Técnico') && item.title === 'Equipos')"
              class="mx-auto"
              id="card"
              width="700px"
              height="230px"
              @click="goTo(item.link)"
              :color="item.color"
            >
              <v-list-item three-line style="display: flex; flex-direction: column; height: 100%">
                 <v-list-item-avatar tile size="40" color="grey">
                  <v-icon size="26">{{ item.icon }}</v-icon>
                </v-list-item-avatar>
                <v-list-item-content class="justify-center" >
                  <v-list-item-title class="headline mb-1 align-center">
                    {{ item.title }}
                  </v-list-item-title>
                </v-list-item-content>
               
              </v-list-item>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import { gsap } from "gsap";
export default {
  name: "HelloWorld",

  data: () => ({
    //agregarle un color class para cada objeto del arreglo item
    // ejemplo : { title: 'Optix', icon: 'mdi-alpha-o-circle', link: '/optix', color: 'red' },
    // y luego agregarle el color a la card con :color="item.color"
    items: [
      {
        title: "Optix",
        icon: "mdi-alpha-o-circle",
        link: "/optix",
        color: "red lighten-1",
      },
      {
        title: "Westnet",
        icon: "mdi-alpha-w-box",
        link: "/westnet",
        color: "light-blue ",
      },
      {
        title: "Bigway",
        icon: "mdi-alpha-b-box",
        link: "/bitway",
        color: "green accent-3",
      },
      {
        title: "Registro de usuarios",
        icon: "mdi-account-multiple",
        link: "/registerView",
        color: "yellow",
      },
      {
        title: "Técnicos",
        icon: "mdi-account-hard-hat-outline",
        link: "/tecnicos",
        color: "orange lighten-2",
      },
      {
        title: "Totales",
        icon: "mdi-format-size",
        link: "/totales",
        color: "purple",
      },
      {
        title: "Asignar Equipos",
        icon: "mdi-router-wireless",
        link: "/equiposView",
        color: "pink",
      },
      {
        title: "Equipos",
        icon: "mdi-router-wireless",
        link: "/equiposTecnicos",
        color: "blue-grey lighten-2",
      },

      // items: [
      //     { title: 'Optix', icon: 'mdi-alpha-o-circle', link: '/optix' },
      //     { title: 'Westnet', icon: 'mdi-alpha-w-box', link: '/westnet' },
      //     { title: 'Bigway', icon: 'mdi-alpha-b-box', link: '/bitway' },
      //     { title: 'Registro de usuarios', icon: 'mdi-account-multiple', link: '/registerView' },
      //     { title: 'Técnicos', icon: 'mdi-account-hard-hat-outline', link: '/tecnicos' },
      //     { title: 'Totales', icon: 'mdi-format-size', link: '/totales' },
      //     { title: 'Asignar Equipos', icon: 'mdi-router-wireless', link: '/equiposView' },
      //     { title: 'Equipos', icon: 'mdi-router-wireless', link: '/equiposTecnicos' },
    ],
  }),
  computed: {
    ...mapState({
      userlogged: (state) => state.userLogged,
      users: (state) => state.users,
      userAuth: (state) => state.userAuth,
      auth: (state) => state.auth,
      userType: (state) => state.userType,
    }),
  },
  mounted() {
    //animar las cards para que aparezcan de manera elegante una a la vez con la libreria three.js
    this.animateCards();
  },
  methods: {
    goTo(link) {
      this.$router.push(link);
    },
    animateCards() {
      //animar con gsap los div que tengan el id card para que aparezcan de a una
      gsap.from("#card", {
        duration: 2.5,
        opacity: 0,
        y: -50,
        stagger: 0.2,
        ease: "power2.out",
      });
    },
  },
};
</script>
